import Error from 'components/templates/Error';
import React from 'react';
export default () => {
    return React.createElement(Error, null);
};
